import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Heading from 'LuxKit/Typography/Heading'

interface Props {
  title: string
  description: string
  itemNumber: number
}

function AgentHubOrderedSellingPointsTile(props: Props) {
  const { itemNumber, title, description } = props
  const intl = useIntl()

  return <Group direction="horizontal" gap={16}>
    <Heading variant="heading3"><i>{intl.formatMessage({
      id: 'xHPYvYGX12',
      defaultMessage: '{itemNumber}.',
      description: 'Numbered selling point index with period for ordered list display',
    }, { itemNumber })}
    </i>
    </Heading>
    <Group direction="vertical" gap={4}>
      <BodyText variant="medium" weight="bold">{title}</BodyText>
      <BodyTextBlock variant="medium">
        {description}
      </BodyTextBlock>
    </Group>
  </Group>
}

export default AgentHubOrderedSellingPointsTile
